/* eslint-disable no-nested-ternary */

import Button from '@material-ui/core/Button'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import withWidth from '@material-ui/core/withWidth'
import { useState } from 'react'
import styled, { ThemeProvider } from 'styled-components'

import useWindowSize from '../../hooks/useWindowSize'
import theme from '../../utils/theme'

const useStyles = makeStyles(theme => ({
  scrollButton: {
    minWidth: 0,
    padding: theme.spacing(1),
    backgroundColor: 'white',
    height: 50,
  },
}))

function NewStepper(props) {
  const { activeStep, className, headercolour, headertextcolour, labelClass, steps, width } = props

  const classes = useStyles()
  const { width: windowWidth } = useWindowSize()
  const [scrollIndex, setScrollIndex] = useState(0)
  const isMobile = windowWidth <= 768
  const activeSteps =
    activeStep <= 6 && scrollIndex === 6
      ? steps
      : activeStep >= 6
        ? steps.slice(-(steps.length - 6))
        : steps.slice(0, 6)
  const activeStepsForMobile =
    activeStep <= 3 && scrollIndex === 3
      ? steps
      : activeStep >= 6
        ? steps.slice(-(steps.length - 6))
        : activeStep >= 3
          ? steps.slice(scrollIndex + 3, steps.length)
          : steps.slice(0, 9)

  const handlePrev = stepsCount => {
    setScrollIndex(Math.max(0, scrollIndex - stepsCount))
  }

  const handleNext = stepsCount => {
    setScrollIndex(Math.min(scrollIndex + stepsCount, steps.length - 1))
  }
  const stepCount = activeStep >= 6 ? activeStep : scrollIndex
  const mobileStepCount = activeStep >= 3 ? activeStep : scrollIndex

  const renderComponent = (stepsCount, activeSteps, stepCount, borderIndex) => {
    const active = !isMobile
      ? activeStep >= stepsCount
        ? activeStep - stepsCount
        : activeStep < stepsCount && scrollIndex === stepsCount
          ? activeStep + stepsCount
          : activeStep
      : activeStep < 3
        ? activeStep
        : activeStep >= 6
          ? activeStep - 6
          : activeStep >= stepsCount
            ? activeStep - stepsCount
            : activeStep < stepsCount && scrollIndex === stepsCount
              ? activeStep + stepsCount
              : activeStep
    return (
      <>
        {width !== 'xs' ? (
          <ModalSteps
            className={className}
            activeStep={active}
            connector={null}
            headercolour={headercolour}
            headertextcolour={headertextcolour}
          >
            {scrollIndex !== 0 && (
              <Button
                className={classes.scrollButton}
                onClick={() => {
                  handlePrev(stepsCount)
                }}
                disabled={scrollIndex === 0}
                style={{
                  borderRadius: '4px 0 0 0',
                }}
              >
                &#60;
              </Button>
            )}
            {activeSteps.slice(scrollIndex, scrollIndex + stepsCount).map((stepLabel, index) => (
              <Step
                style={{
                  flex: '1',
                  padding: '0',
                  borderRadius:
                    index + 1 + scrollIndex === borderIndex
                      ? '0 0 0 0'
                      : index === 0
                        ? '4px 0 0 0'
                        : index === steps.length - 1
                          ? '0 4px 0 0'
                          : '0 0 0 0',
                  overflow: 'hidden',
                }}
                key={stepLabel}
              >
                <StyledStepLabel
                  headertextcolour={headertextcolour}
                  headercolour={headercolour}
                  classes={{
                    active: 'active',
                    completed: 'completed',
                    label: 'label',
                  }}
                  className={labelClass}
                  icon={null}
                >
                  <div>
                    {index + 1 + stepCount}. {stepLabel}
                  </div>
                </StyledStepLabel>
              </Step>
            ))}
            {activeStep >= stepsCount ||
              (steps.length > stepsCount && scrollIndex <= steps.length - stepsCount && (
                <Button
                  className={classes.scrollButton}
                  onClick={() => {
                    handleNext(stepsCount)
                  }}
                  disabled={scrollIndex >= steps.length - stepsCount}
                  style={{
                    borderRadius: '0 4px 0 0',
                  }}
                >
                  &#62;
                </Button>
              ))}
          </ModalSteps>
        ) : (
          <ModalSteps className={className} activeStep={active} connector={null} headertextcolour={headertextcolour}>
            {scrollIndex !== 0 && (
              <Button
                className={classes.scrollButton}
                onClick={() => {
                  handlePrev(stepsCount)
                }}
                disabled={scrollIndex === 0}
                style={{
                  borderRadius: '4px 0 0 0',
                }}
              >
                &#60;
              </Button>
            )}
            {activeSteps.slice(scrollIndex, scrollIndex + stepsCount).map((stepLabel, index) => (
              <Step style={{ flex: '1', padding: '0' }} key={stepLabel}>
                <StyledStepLabel
                  headertextcolour={headertextcolour}
                  headercolour={headercolour}
                  classes={{
                    active: 'active',
                    completed: 'completed',
                    label: 'label',
                  }}
                  className={labelClass}
                  icon={null}
                >
                  <div>
                    {index + 1 + stepCount}. {stepLabel}
                  </div>
                </StyledStepLabel>
              </Step>
            ))}
            {activeStep >= stepsCount ||
              (steps.length > stepsCount && scrollIndex <= steps.length - stepsCount && (
                <Button
                  className={classes.scrollButton}
                  onClick={() => {
                    handleNext(stepsCount)
                  }}
                  disabled={scrollIndex >= steps.length - stepsCount}
                  style={{
                    borderRadius: '0 4px 0 0',
                  }}
                >
                  &#62;
                </Button>
              ))}
          </ModalSteps>
        )}
      </>
    )
  }
  return (
    <ThemeProvider theme={theme}>
      {isMobile
        ? renderComponent(3, activeStepsForMobile, mobileStepCount, 4)
        : renderComponent(6, activeSteps, stepCount, 7)}
    </ThemeProvider>
  )
}

const ModalSteps = styled(Stepper)`
  && {
    background-color: ${props => props.headercolour};
    padding: 0;
  }
`

const StyledStepLabel = styled(StepLabel)`
  && {
    .active,
    .completed,
    .label {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      color: ${props => props.theme.colors.darkGrey};
      opacity: 1;
      font-size: ${props => props.theme.typography.fontSizeSm};
    }
    .active {
      background-color: ${props => props.headercolour};
      color: ${props => props.theme.header.textColor};
    }
    .completed {
      color: #d4deea;
    }
    text-align: center;
    background-color: ${props => props.theme.colors.lightGrey};
    margin: 0;
    border: none;
    .stepMobile {
      padding: 0.5rem !important;
    }
  }
`

const FormStepper = withStyles()(withWidth()(NewStepper))
FormStepper.displayName = 'Stepper'

export default FormStepper
